import { useEffect, useState } from "react";
import api from "@/lib/api";

export const CategoriasAsignadas = ({ value, onChange, title = "Categorías de productos asignadas", hint = "El vendedor sólo verá y podrá vender productos de estas categorías. Sin categorías = ningún producto." }) => {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    api.get("/products/categorias").then(({ data }) => setCats(data || [])).catch(() => {});
  }, []);
  const sel = value || [];
  const toggle = (c) => onChange(sel.includes(c) ? sel.filter((x) => x !== c) : [...sel, c]);
  return (
    <div className="mt-2 border-t border-zinc-100 pt-4" data-testid="categorias-asignadas">
      <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-500 font-semibold">{title}</div>
      <div className="text-[11px] text-zinc-500 mb-2">{hint}</div>
      {cats.length === 0 ? (
        <div className="text-xs text-zinc-400">No hay categorías registradas en productos.</div>
      ) : (
        <div className="flex flex-wrap gap-2">
          {cats.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => toggle(c)}
              data-testid={`cat-asig-${c}`}
              className={`px-3 py-1 rounded-full text-xs border transition-colors ${sel.includes(c) ? "bg-[#002FA7] text-white border-[#002FA7]" : "bg-white text-zinc-700 border-zinc-300 hover:bg-zinc-50"}`}
            >
              {c}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
